import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import template from './ns-radio-button.html';

/**
 * <p>The ns-radio-button should be used for all radio buttons at nuskin. It toggles between distinct choices.</p>
 *
 * <h1>Radio Button</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *    <radio-group>
 *     <ns-radio-button label="Example Radio" name="test" checked></ns-radio-button>
 *     <ns-radio-button label="Example Radio" name="test"></ns-radio-button>
 *    </radio-group>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsRadioButton extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-radio-button";
  }

  static get template() {
    let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      /**
       * name is used to group specific buttons together, all buttons sharing the same name are mutually exclusive choices
       */
      name: {
        type: String,
        value: "radio-button-name"
      },
      /**
       * checked is used to pre-fill the value of the radio button as true
       */
      checked: {
        type: Boolean,
        value: false,
        notify: true,
        reflectToAttribute: true
      },
      /**
       * label is used to show a choice name on the radio button such as "Female", "Yes" or "Option 1"
       */
      label: String,
      /**
       * name is used to group the radio choices
       */
      name: String,
      /**
       * value is used to apply a specific value to the radio button such as "F", "Y", or "1"
       */
      value: String,
      /**
       * id is used to make a distinction between specific choices despite various radio buttons on the screen at a time
       */
      id: String,
      /**
       * disabled is used to make a radio button option unavailable as an choice
       */
      disabled: {
        type: Boolean,
        value: false
      }
    };
  }

  ready() {
    super.ready();
  }

  toggleRadio() {
    var nameGroup = document.getElementsByName(this.name);
    for (var i = 0; i < nameGroup.length; i++) {
      nameGroup[i].checked = false;
    }
    this.checked = true;
  }

}

customElements.define(NsRadioButton.is, NsRadioButton);
